import React, { useState } from "react";
import { HeaderProps } from "./header.model";
import { Box, IconButton, Menu, MenuItem, Tooltip, useTheme } from "@mui/material";
import { WrapperHeader } from "./header.style";

import LogoHabi from "@/assets/logo.png";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";

const Header: React.FC<HeaderProps> = ({ signOut }) => {
  useTheme();
  const [anchorElUser, setAnchorElUser] = useState<null | HTMLElement>(null);

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorElUser(null);
  };

  const actions = [
    {
      label: "Cerrar sesión",
      onClick: signOut,
    },
  ];

  return (
    <WrapperHeader>
      <a href="/">
        <div className="header__content-logo">
            <img src={LogoHabi} alt="Logo habi" />
        </div>
      </a>

      <Box sx={{ flexGrow: 0 }}>
        <Tooltip title="Open settings">
          <IconButton onClick={handleOpen} sx={{ p: 0 }}>
            <AccountCircleIcon 
              sx={{ 
                color: theme => theme.palette.text.primary
              }} 
              fontSize="large" 
            />
          </IconButton>
        </Tooltip>
        <Menu
          sx={{ mt: "45px" }}
          id="menu-appbar"
          anchorEl={anchorElUser}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          keepMounted
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          open={Boolean(anchorElUser)}
          onClose={handleClose}
        >
          {actions.map((action: { label: string; onClick: () => void }) => (
            <MenuItem key={action.label} onClick={action.onClick}>
              <div className="header__text-action">{action.label}</div>
            </MenuItem>
          ))}
        </Menu>
      </Box>
    </WrapperHeader>
  );
};

export default Header;
